module.exports = __webpack_public_path__ + "static/media/Roboto-Black.fdd88b74.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Black.woff
// module id = 538
// module chunks = 0